import { motion, useReducedMotion } from "framer-motion";
import { Construction } from "lucide-react";
import { fadeUp } from "../lib/motion";

// UX-01 §1 "OUT of scope (later prompts)": every non-cockpit nav destination is stubbed here so
// the shell/nav is fully wired without building screens this prompt doesn't own.
export default function StubPage({ title }) {
  const reducedMotion = useReducedMotion();
  return (
    <motion.div {...fadeUp(reducedMotion)} className="solid-surface rounded-[14px] p-16 flex flex-col items-center text-center max-w-2xl" data-testid="stub-page">
      <Construction size={28} style={{ color: "var(--scarlet-accent)" }} className="mb-3" />
      <h2 className="font-bold text-lg" style={{ color: "var(--scarlet-text)" }}>{title}</h2>
      <p className="text-sm mt-1" style={{ color: "var(--scarlet-text-secondary)" }}>This screen is built in a later prompt. The shell and navigation are already wired for it.</p>
    </motion.div>
  );
}
